import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

let isShowMessage = true

export function request (method, url, parameter, isToken) { // , requestData
  let data = {}
  let params = {}
  let headers= {}
  if (isToken) {
    headers = {
      'Content-Type': 'application/json',
      'card': localStorage.getItem('access_token'),
    }
  } else {
    headers = {
      'Content-Type': 'application/json'
    }
  }
  // Target-URL
  if (window.config.isCorsProxy) {
    headers['Target-URL'] = window.config.baseURL + url
  }
  if (method === 'GET' || method === 'DELETE') {
    params = parameter
  } else {
    data = parameter
  }
  return axios({
    method: method,
    baseURL: window.config.isCorsProxy ? window.config.corsProxyUrl : window.config.baseURL,
    url: window.config.isCorsProxy ? '' : url,
    timeout: 30000,
    headers: headers,
    params: params,
    data: data,
  }).then((response) => {
    const res = response.data

    if (response.status === 200) {
      if (url === '/oauth/token') {
        if (res.error_description) {
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 2 * 1000,
            showClose: true
          })
        } else {
          return res
        }
        return false
      }
      if (res.code === 0) {
        return res
      } else if (res.code == -100) {
        if (url != '/admin/logout') {
          localStorage.removeItem('access_token')
          console.log(url)
          router.replace('/')
          Message({
            message: '登录已过期，请重新登录',
            type: 'error',
            duration: 2 * 1000,
            showClose: true
          })
        }
        return false
      } else {
        if (isShowMessage) {
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 2 * 1000,
            showClose: true
          })
          isShowMessage = false
          setTimeout(function () {
            isShowMessage = true
          }, 5000)
        }
        return res
      }
    } else if (response.status === 401) {
      localStorage.removeItem('access_token')
      router.replace('/')
      if (isShowMessage) {
        Message({
          message: '登录已过期，请重新登录',
          type: 'error',
          duration: 2 * 1000,
          showClose: true
        })
        isShowMessage = false
        setTimeout(function () {
          isShowMessage = true
        }, 5000)
        
      }
      return false
    } else {
      if (url != '/admin/logout') {
        if (isShowMessage) {
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 2 * 1000,
            showClose: true
          })
          isShowMessage = false
          setTimeout(function () {
            isShowMessage = true
          }, 5000)
        }
      }
      return false
    }
  }).catch((error) => {
    if (!isToken) {
      if (error.response.status === 401) {
        let message = error.response.data.error_description
        Message({
          message: message || '登录授权失败，用户密码不正确',
          type: 'error',
          duration: 2 * 1000,
          showClose: true
        })
        return error
      } else {
        Message({
          message: '登录失败',
          type: 'error',
          duration: 2 * 1000,
          showClose: true
        })
        return error
      }
    } else {
      if (error.response.status === 401) {
        localStorage.removeItem('access_token')
        router.push('/')
        return false
      }
    }
  })
}

export function download (method, url, parameter, name) {
  let data = {}
  let params = {}
  let headers = {
    'Content-Type': 'application/json',
    'card': localStorage.getItem('access_token'),
  }
  // Target-URL
  if (window.config.isCorsProxy) {
    headers['Target-URL'] = window.config.baseURL + url
  }
  if (method === 'GET') {
    params = parameter
  } else {
    data = parameter
  }
  return axios({
    method: method,
    baseURL: window.config.isCorsProxy ? window.config.corsProxyUrl : window.config.baseURL,
    url: window.config.isCorsProxy ? '' : url,
    timeout: 30000,
    headers: headers,
    params: params,
    data: data,
    responseType: 'blob'
  }).then((response) => {
    const res = response.data
    if (response.status === 200) {
      return export2Excel(res, name)
    } else if (response.status === 401) {
      localStorage.removeItem('access_token')
      router.replace('/')
      if (isShowMessage) {
        Message({
          message: '登录已过期，请重新登录',
          type: 'error',
          duration: 2 * 1000,
          showClose: true
        })
        isShowMessage = false
        setTimeout(function () {
          isShowMessage = true
        }, 5000)
      }
    } else {
      if (isShowMessage) {
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 2 * 1000,
          showClose: true
        })
        isShowMessage = false
        setTimeout(function () {
          isShowMessage = true
        }, 5000)
      }
    }
    return response
  }).catch((error) => {
    if (JSON.stringify(error).indexOf('401') > -1) {
      localStorage.removeItem('access_token')
      router.replace('/')
      if (isShowMessage) {
        Message({
          message: '登录已过期，请重新登录',
          type: 'error',
          duration: 2 * 1000,
          showClose: true
        })
        isShowMessage = false
        setTimeout(function () {
          isShowMessage = true
        }, 5000)
      }
    }
    return error
  })
}

function export2Excel(res, params) {
  let blob = new Blob([res], {type: res.type})
  let downloadElement = document.createElement('a')
  let href = window.URL.createObjectURL(blob); //创建下载的链接
  downloadElement.href = href;
  downloadElement.download = params + '.xls'; //下载后文件名
  document.body.appendChild(downloadElement);
  downloadElement.click(); //点击下载
  document.body.removeChild(downloadElement); //下载完成移除元素
  window.URL.revokeObjectURL(href); //释放blob对象
  return true
}
